import { AvailableProposal } from "src/types/loan-application";

export default function useMockNorthridgeProposal(price: number) {
  return {
    proposalId: Number(10101),
    lenderReference: 'NORTHRIDGE_REF',
    isPrime: true,
    isPreferredAcceptance: true,
    minVehicleAgeAtStart: null,
    maxVehicleAgeAtStart: null,
    maxVehicleAgeAtEnd: 15,
    minMileage: null,
    maxMileage: Number(90000),
    maxLendAmount: Number(150000),
    minLendAmount: Number(2500),
    minLendAmountPcp: Number(5000),
    minTerm: Number(24),
    maxTerm: Number(60),
    loanProposalStatus: "ProvisionalAcceptance",
    maxVanAgeAtEnd: 10,
    maxVehicleAgeAtEnd_HP_Electric: 9,
    excludedVehicles: [
      {
          "make": "Make",
          "model": "Model",
          "derivative": "Derivative"
      },
      {
          "make": "Ferrari",
          "model": "",
          "derivative": ""
      },
      {
          "make": "Lamborghini",
          "model": "",
          "derivative": ""
      },
      {
          "make": "Maserati",
          "model": "",
          "derivative": ""
      },
      {
          "make": "Fisker",
          "model": "",
          "derivative": ""
      }
    ],

    amountToFinance: Number(price),
    apr: null,
    flatRate: null,
    financeCompany: "Northridge",
    financeCompanyId: 75,
  
    rank: null,
  } as AvailableProposal;
}
